/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost } from '../fn/project-penalties-template/api-project-penalties-template-create-project-penalty-template-post';
import { ApiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Params } from '../fn/project-penalties-template/api-project-penalties-template-create-project-penalty-template-post';
import { apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain } from '../fn/project-penalties-template/api-project-penalties-template-create-project-penalty-template-post-plain';
import { ApiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain$Params } from '../fn/project-penalties-template/api-project-penalties-template-create-project-penalty-template-post-plain';
import { apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete } from '../fn/project-penalties-template/api-project-penalties-template-delete-project-penalty-template-delete';
import { ApiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Params } from '../fn/project-penalties-template/api-project-penalties-template-delete-project-penalty-template-delete';
import { apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Plain } from '../fn/project-penalties-template/api-project-penalties-template-delete-project-penalty-template-delete-plain';
import { ApiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Plain$Params } from '../fn/project-penalties-template/api-project-penalties-template-delete-project-penalty-template-delete-plain';
import { apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet } from '../fn/project-penalties-template/api-project-penalties-template-get-project-penalties-templates-get';
import { ApiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Params } from '../fn/project-penalties-template/api-project-penalties-template-get-project-penalties-templates-get';
import { apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Plain } from '../fn/project-penalties-template/api-project-penalties-template-get-project-penalties-templates-get-plain';
import { ApiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Plain$Params } from '../fn/project-penalties-template/api-project-penalties-template-get-project-penalties-templates-get-plain';
import { apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost } from '../fn/project-penalties-template/api-project-penalties-template-update-project-penalty-template-post';
import { ApiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Params } from '../fn/project-penalties-template/api-project-penalties-template-update-project-penalty-template-post';
import { apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Plain } from '../fn/project-penalties-template/api-project-penalties-template-update-project-penalty-template-post-plain';
import { ApiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Plain$Params } from '../fn/project-penalties-template/api-project-penalties-template-update-project-penalty-template-post-plain';
import { CreateProjectPenaltyTemplateCommandResult } from '../models/create-project-penalty-template-command-result';
import { DeleteProjectPenaltyTemplateCommandResult } from '../models/delete-project-penalty-template-command-result';
import { GetProjectPenaltyTemplatesQueryResult } from '../models/get-project-penalty-templates-query-result';
import { UpdateProjectPenaltyTemplateCommandResult } from '../models/update-project-penalty-template-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectPenaltiesTemplateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet()` */
  static readonly ApiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGetPath = '/api/ProjectPenaltiesTemplate/GetProjectPenaltiesTemplates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Plain$Response(params?: ApiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPenaltyTemplatesQueryResult>> {
    return apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Plain(params?: ApiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Plain$Params, context?: HttpContext): Observable<GetProjectPenaltyTemplatesQueryResult> {
    return this.apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectPenaltyTemplatesQueryResult>): GetProjectPenaltyTemplatesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Response(params?: ApiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPenaltyTemplatesQueryResult>> {
    return apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet(params?: ApiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Params, context?: HttpContext): Observable<GetProjectPenaltyTemplatesQueryResult> {
    return this.apiProjectPenaltiesTemplateGetProjectPenaltiesTemplatesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectPenaltyTemplatesQueryResult>): GetProjectPenaltyTemplatesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost()` */
  static readonly ApiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePostPath = '/api/ProjectPenaltiesTemplate/CreateProjectPenaltyTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain$Response(params?: ApiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectPenaltyTemplateCommandResult>> {
    return apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain(params?: ApiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain$Params, context?: HttpContext): Observable<CreateProjectPenaltyTemplateCommandResult> {
    return this.apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectPenaltyTemplateCommandResult>): CreateProjectPenaltyTemplateCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Response(params?: ApiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectPenaltyTemplateCommandResult>> {
    return apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost(params?: ApiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Params, context?: HttpContext): Observable<CreateProjectPenaltyTemplateCommandResult> {
    return this.apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectPenaltyTemplateCommandResult>): CreateProjectPenaltyTemplateCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost()` */
  static readonly ApiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePostPath = '/api/ProjectPenaltiesTemplate/UpdateProjectPenaltyTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Plain$Response(params?: ApiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectPenaltyTemplateCommandResult>> {
    return apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Plain(params?: ApiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Plain$Params, context?: HttpContext): Observable<UpdateProjectPenaltyTemplateCommandResult> {
    return this.apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectPenaltyTemplateCommandResult>): UpdateProjectPenaltyTemplateCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Response(params?: ApiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectPenaltyTemplateCommandResult>> {
    return apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost(params?: ApiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Params, context?: HttpContext): Observable<UpdateProjectPenaltyTemplateCommandResult> {
    return this.apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectPenaltyTemplateCommandResult>): UpdateProjectPenaltyTemplateCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete()` */
  static readonly ApiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDeletePath = '/api/ProjectPenaltiesTemplate/DeleteProjectPenaltyTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Plain$Response(params?: ApiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectPenaltyTemplateCommandResult>> {
    return apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Plain(params?: ApiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectPenaltyTemplateCommandResult> {
    return this.apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectPenaltyTemplateCommandResult>): DeleteProjectPenaltyTemplateCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Response(params?: ApiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectPenaltyTemplateCommandResult>> {
    return apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete(params?: ApiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Params, context?: HttpContext): Observable<DeleteProjectPenaltyTemplateCommandResult> {
    return this.apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectPenaltyTemplateCommandResult>): DeleteProjectPenaltyTemplateCommandResult => r.body)
    );
  }

}
